import { render, staticRenderFns } from "./SmallProductionBarWithNumbers.vue?vue&type=template&id=2d53d722&scoped=true&"
import script from "./SmallProductionBarWithNumbers.vue?vue&type=script&lang=js&"
export * from "./SmallProductionBarWithNumbers.vue?vue&type=script&lang=js&"
import style0 from "./SmallProductionBarWithNumbers.vue?vue&type=style&index=0&id=2d53d722&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d53d722",
  null
  
)

export default component.exports